import type { FormFieldOptionItem } from "@/server/platform/db/schema/forms";

/** ຕົວເລືອທີ່ຍັງເປີດໃຫ້ຜູ້ຕອບເລືອກໄດ້ (ຄ່າເລີ່ມຕົ້ນ = ເປີດ) */
export function isFormFieldOptionEnabled(o: FormFieldOptionItem): boolean {
  return o.enabled !== false;
}

export function normalizeFormFieldOptions(
  options: FormFieldOptionItem[] | null | undefined,
): FormFieldOptionItem[] {
  if (!Array.isArray(options)) return [];
  return options;
}

/** ຕົວເລືອທີ່ສະແດງໃນຟອມ public / ຮັບ submit ໃໝ່ */
export function selectableFormFieldOptions(
  options: FormFieldOptionItem[] | null | undefined,
): FormFieldOptionItem[] {
  return normalizeFormFieldOptions(options).filter(isFormFieldOptionEnabled);
}

export function selectableFormFieldOptionValues(
  options: FormFieldOptionItem[] | null | undefined,
): string[] {
  return selectableFormFieldOptions(options).map((o) => o.value);
}

/** ຕົວເລືອທັງໝົດ (ລວມປິດ) — ສຳລັບ label ຄຳຕອບເກົ່າ / filter admin */
export function allFormFieldOptionValues(
  options: FormFieldOptionItem[] | null | undefined,
): string[] {
  return normalizeFormFieldOptions(options).map((o) => o.value);
}

/** options ສຳລັບ public GET — ສົ່ງແຕ່ຕົວເລືອທີ່ເປີດ */
export function publicFormFieldOptions(
  options: FormFieldOptionItem[] | null | undefined,
): FormFieldOptionItem[] | null {
  const selectable = selectableFormFieldOptions(options);
  return selectable.length > 0 ? selectable : null;
}
